export type ReturnFraudType = 'DENIED' | 'WARNED' | 'WARNEDINVALID';
/**
 * Analytics event descriptions for when user gets a fraud modal.
 */
export const DENIED_OR_WARNED_EVENT_NAME = {
  DENIED: 'tre return denied',
  WARNED: 'tre return warning',
  WARNEDINVALID: 'tre return warning',
};

/**
 * Analytics event descriptions for when user copies text to clipboard.
 */
export const COPY_TEXT_EVENT_DESCRIPTION = {
  DENIED: 'tre return denied overlay: copy text to clipboard click',
  WARNED: 'tre return warning overlay: copy text to clipboard click',
  WARNEDINVALID: 'tre return warning overlay: copy text to clipboard click',
};

/**
 * Customer-facing error/advisory copy that is both rendered to the user AND
 * sent as the Adobe `post page error` event `message`. Keeping a single source
 * of truth here guarantees the tagged message matches the visible message
 * (the drift MYACCR-2637 exists to prevent). Import these at both the render
 * site and the tagging site.
 */
export const RETURN_TECHNICAL_ERROR_WITH_ASSISTANCE =
  "We're sorry. There was a temporary technical error. Please try again shortly or call 1-866-333-3551 for assistance.";

export const POLICY_VALIDATOR_INELIGIBLE_ITEMS_MESSAGE =
  "We're sorry. The items below can't be returned. See our Returns Policy for more options.";

export const UPS_WEIGHT_LIMIT_MESSAGE =
  "UPS drop-off returns can't exceed 150 lbs. You can reduce the selected return quantities. Or you can return all items in store.";

export const LORP_SCHEDULE_PICKUP_ERROR_MESSAGE =
  'There was an issue finding an available pickup date. To check for additional dates, submit this return request and our carrier will contact you and schedule a custom date.';

export const LORP_UNRECOGNIZED_ADDRESS_MESSAGE =
  "We don't recognize the address provided. Verify the information is correct before you continue.";

export const LORP_VERIFY_PICKUP_ADDRESS_MESSAGE =
  'Please verify your pickup address is correct before continuing.';

export const LORP_ZIP_REQUIRED_MESSAGE =
  'Please provide your 5-digit ZIP Code.';

export const LORP_ADDRESS_REQUIRED_MESSAGE = 'Please provide your address.';

/**
 * Schedule Return Pickup (Schedule RPM) `myAccount.settings` values (→ prop63).
 * These fire as `button submission` events only when the Schedule RPM flow is
 * active (`isScheduledPickupEnabled()`), layered over the eligible LORP flow.
 * See MYACCR-2641 (spec Section 5).
 */
export const SCHEDULE_RPM_RETURN_PICKUP_SETTINGS =
  'purchase history: order details: return pickup';

export const SCHEDULE_RPM_PICKUP_DATE_SETTINGS =
  'purchase history: order details: return pickup date';

export const SCHEDULE_RPM_FINALIZE_SETTINGS =
  'purchase history: order details: return pickup finalize return';

export const ORDER_BARCODE_ERROR_MESSAGE =
  'We had a technical issue and couldn’t generate your barcode. You can still give the order number to the store associate to process your return.';

export const ITEMS_NOT_PROCESSED_MESSAGE =
  'We’re sorry. There was a temporary technical error processing the items below. Please try again or call 1-800-430-3376 for assistance.';

/**
 * Retry-failed partial-failure copy. Rendered to the customer as two separate
 * paragraphs (`_INTRO` + `_ACTION`); the concatenated `_MESSAGE` is what gets
 * sent to analytics so the payload reflects the full visible text.
 */
export const ITEMS_NOT_PROCESSED_RETRY_FAILED_INTRO =
  'We’re sorry. There was a temporary technical error processing the items below.';

export const ITEMS_NOT_PROCESSED_RETRY_FAILED_ACTION =
  'Please try again or return to Order Details to see the status of your return request.';

export const ITEMS_NOT_PROCESSED_RETRY_FAILED_MESSAGE = `${ITEMS_NOT_PROCESSED_RETRY_FAILED_INTRO} ${ITEMS_NOT_PROCESSED_RETRY_FAILED_ACTION}`;
